export default {
  padding: '0.5rem 0',
  borderRadius: '4px',
  backgroundColor: 'rgba(251,215,96,.21)',
  color: 'var(--dark-teal)',
};
